import React from 'react';
import { handCursor, primaryFgColor } from '../../Constant/constant';
import { TestimonialCardLayout, TestimonialBody, TestimonialImg } from '../../Styles';
import './index.css'

const TestimonialCard = (props) => {
  return (
    <TestimonialCardLayout className="home-testi-layout">
      <TestimonialImg className="home-testi-img">
        <img
          style={{ objectFit: 'cover', objectPosition: 'center', height: 180, width: 180, borderRadius: '50%', overflow: 'hidden', margin: '8% auto' }}
          src={props.info.img}
          alt="Profile"
        // src="https://images.unsplash.com/photo-1463453091185-61582044d556?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80"
        />
      </TestimonialImg>
      <TestimonialBody className="home-testi-body">
        <svg width="40" height="32" viewBox="0 0 80 74" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.2396 17.9806C14.746 14.2982 20.0519 12.4316 27.0072 12.4316H29.5064V19.2564L27.497 19.6462C24.0731 20.3096 21.6913 21.6145 20.4167 23.5295C19.7517 24.5611 19.3745 25.7424 19.3221 26.9576H27.0072C27.67 26.9576 28.3057 27.2127 28.7744 27.6667C29.2431 28.1207 29.5064 28.7365 29.5064 29.3786V46.3255C29.5064 48.9959 27.2646 51.1675 24.508 51.1675H9.51267C8.84984 51.1675 8.21415 50.9125 7.74546 50.4584C7.27677 50.0044 7.01346 49.3886 7.01346 48.7465V36.6416L7.02095 29.5747C6.99846 29.306 6.52361 22.9388 11.2396 17.9806ZM51.9993 51.1675H37.004C36.3412 51.1675 35.7055 50.9125 35.2368 50.4584C34.7681 50.0044 34.5048 49.3886 34.5048 48.7465V36.6416L34.5123 29.5747C34.4898 29.306 34.015 22.9388 38.731 17.9806C42.2374 14.2982 47.5432 12.4316 54.4985 12.4316H56.9977V19.2564L54.9884 19.6462C51.5644 20.3096 49.1827 21.6145 47.9081 23.5295C47.243 24.5611 46.8658 25.7424 46.8134 26.9576H54.4985C55.1614 26.9576 55.797 27.2127 56.2657 27.6667C56.7344 28.1207 56.9977 28.7365 56.9977 29.3786V46.3255C56.9977 48.9959 54.7559 51.1675 51.9993 51.1675Z" fill="#979DAC" />
        </svg>
        <p id="is-card-mobile" style={{ margin: '0', paddingRight: 30, fontSize: 16, fontWeight: 400 }}>{props.info.comment}</p>
        {/* <p style={{ margin: '0', fontSize: 16 }}>steve is a slow traveler who loves anything that can be described as remote, country or outback. She dabbles in documentary making and seeks out With a passion for helping small business and utilize the internet for growth.</p> */}
        <br />
        <div style={{ fontWeight: 600 }}>
          <span className="is-card-title-mobile" style={{ float: 'left', width: 'auto', color: primaryFgColor, fontSize: 20, paddingRight: 16 }}>{props.info.name}</span>
          <span className="is-card-title-mobile"
            style={{ float: 'left', width: '45%', color: primaryFgColor, fontSize: 20, borderLeft: '2px solid', borderColor: primaryFgColor, paddingLeft: 16, textAlign: 'left' }}
          // onClick={() => window.open(props.info.link)}
          >
            <a href={props.info.link} id="anchor-remove" style={{ cursor: handCursor }}>
              {props.info.position}
            </a>
          </span>
        </div>
      </TestimonialBody>
    </TestimonialCardLayout>
  );
}

export default TestimonialCard;